module.exports = {
  siteTitle: "Drewski Blogs - Wordsmithery Platform producted by Drewski Labs", // <title>
  shortSiteTitle: "Drewski Blogs - by Drewski Labs", // <title> ending for posts and pages
  siteDescription: "A fusion of thoughts, feelings, expressions, and more into a collection of wordsmithed entries.",
  siteUrl: "https://blog.drewskilabs.com",
  // pathPrefix: "",
  siteImage: "blog-thumbnail.jpg",
  siteLanguage: "en",

  /* author */
  authorName: "Drewski Labs",
  authorTwitterAccount: "DrewskiLabs",
  authorInstagram: "drewskilabs",
  authorFacebook: "@DrewskiLabs",

  /* info */
  headerTitle: "Drewski Blogs",
  headerSubTitle: "produced by Drewski Labs",

  /* manifest.json */
  manifestName: "Wordsmithery by Drewski Labs",
  manifestShortName: "DrewskiBlogs", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",

  // social
  authorSocialLinks: [
    { name: "twitter", url: "https://twitter.com/DrewskiLabs" },
    { name: "facebook", url: "https://www.facebook.com/DrewskiLabs/" },
    { name: "instagram", url: "https://www.instagram.com/drewskilabs/" }
  ]
};
